
// mission-card slider start


$('.brand-mission__items').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 800,
    pauseOnHover: true,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true
            }
        }
    ]
});


$('.mission-card__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.mission-card__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});

// mission-card slider end




// brand-built start

if ($(Window).width() < 768) {
    $('.brand-built__items').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
    });
}

// brand-built end



// Team Progress Card start About Page

$('.meet-team__items').slick({
    mobileFirst: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 800,
    pauseOnHover: true,
    responsive: [{
        breakpoint: 1024,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            autoplay: true,
            autoplaySpeed: 3000,
            speed: 800,
            pauseOnHover: true,
            prevArrow: $('.meet-team__arrow-left'),
            nextArrow: $('.meet-team__arrow-right'),
        }
    }]

});


// Team Progress Card End About Page